import React from "react";
import AssistantSearch from "./AssistantSearch";

export default function AiAssistant({
  value = "",
  onChange,
  quickActions = [],
  variant = "",
  onQuickActionClick,
  onOpenQrAfterGenerate,
}) {
  return (
    <AssistantSearch
      userName={sessionStorage.getItem("UserName") || "User"}
      value={value}
      onChange={onChange}
      quickActions={quickActions}
      variant={variant}
      onQuickActionClick={onQuickActionClick}
      onOpenQrAfterGenerate={onOpenQrAfterGenerate}
    />
  );
}
